import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ImageList, ImageListItem } from '@mui/material';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';

import SectionTitle from '../components/section-title/SectionTitle';
import EmptyConnectionsDisclaimer from './components/empty-connections-disclaimer/EmptyConnectionsDisclaimer';
import ContentCard from './components/content-card/ContentCard';
import CommonButton, { BUTTON_STYLES } from '../../../components/common-button/CommonButton';
import useGridElementsCount from '../../hooks/useGridElementsCount';
import { useProject } from '../../../context/ProjectContext';

import scss from './Connections.module.scss';

function Connections() {
  const { t } = useTranslation('story');
  const { actions } = useProject();

  const [selectedIds, setSelectedIds] = useState([]);

  const generatedContent = useSelector((state) => state.story.generatedContent);
  const isStorySending = useSelector((state) => state.story.isStorySending);

  const colsCount = useGridElementsCount();

  const handleToggleSelect = useCallback((contentIds) => {
    setSelectedIds((prev) => {
      const allSelected = contentIds.length > 0 && contentIds.every((id) => prev.includes(id));

      if (allSelected) {
        return prev.filter((id) => !contentIds.includes(id));
      }

      return [...new Set([...prev, ...contentIds])];
    });
  }, []);

  const handleSend = async () => {
    if (!selectedIds.length) {
      return;
    }
    await actions('sendStory', { ids: selectedIds }).unwrap();
    setSelectedIds([]);
  };

  return (
    <div className={scss.wrapper}>
      <SectionTitle title={t('generatedContent')}>
        <CommonButton
          styleColor={BUTTON_STYLES.PRIMARY}
          onClick={handleSend}
          disabled={!selectedIds.length}
          isLoading={isStorySending}
          className={scss.sendButton}
          LeftIcon={<ShareOutlinedIcon />}>
          {t('send')}
        </CommonButton>
      </SectionTitle>

      <div className={scss.contentWrapper}>
        {!generatedContent.length ? <EmptyConnectionsDisclaimer /> : null}

        {generatedContent.length ? (
          <>
            <ImageList variant='masonry' cols={colsCount} gap={8}>
              {generatedContent.map(({ id, contents = [], preview, previewStatus }) => {
                const contentIds = contents.map((content) => content.id);
                const isSelected =
                  contentIds.length > 0 && contentIds.every((contentId) => selectedIds.includes(contentId));

                return (
                  <ImageListItem key={id}>
                    <ContentCard
                      bucketId={id}
                      contents={contents}
                      preview={preview}
                      previewStatus={previewStatus}
                      isSelected={isSelected}
                      onSelect={handleToggleSelect}
                    />
                  </ImageListItem>
                );
              })}
            </ImageList>

            {/* <div className={scss.paginationWrapper}>
              <CommonPagination
                totalItemsCount={totalElements}
                itemsPerPage={size}
                activePage={page}
                onChangePage={handleChangePage}
              />
            </div> */}
          </>
        ) : null}
      </div>
    </div>
  );
}

export default Connections;
